import {Empty, Table} from "antd";
import React from "react";

const columns: any = [
    {
        title: "Serial No",
        dataIndex: "serialNumber",
        key: "serialNumber",
        width: 90
    },
    {
        title: 'Name',
        key: 'name',
        children: [
            {
                title: 'First Name',
                dataIndex: 'name_firstName',
                key: 'name_firstName',
                width: 120,
            },
            {
                title: 'Middle Name',
                dataIndex: 'name_middleName',
                key: 'name_middleName',
                width: 120,
            },
            {
                title: 'Last Name',
                dataIndex: 'name_lastName',
                key: 'name_lastName',
                width: 120,
            },
        ],
    },
    {
        title: 'Gender',
        dataIndex: 'gender',
        key: 'gender',
        width: 100
    },
    {
        title: 'Date Of Birth',
        dataIndex: 'dateOfBirth',
        key: 'dateOfBirth',
        width: 120
    },
    {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
        width: 80
    },
    {
        title: 'Official Email',
        dataIndex: 'officialEmail',
        key: 'officialEmail',
        width: 250
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 250,
    },
    {
        title: 'Contact',
        dataIndex: 'contact',
        key: 'contact',
        width: 140,
    },
    {
        title: 'Joining Date',
        dataIndex: 'joiningDate',
        key: 'joiningDate',
        width: 140,
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: 140,
    },
    {
        title: 'Employee Code',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 120
    },
    {
        title: 'Total Experience',
        dataIndex: 'totalExperience',
        key: 'totalExperience',
        width: 110
    },
    {
        title: 'Blood Group',
        dataIndex: 'bloodGroup',
        key: 'bloodGroup',
        width: 140,
    },
    {
        title: 'Qualification',
        dataIndex: 'qualification',
        key: 'qualification',
        width: 140
    },
    {
        title: 'Designation',
        dataIndex: 'designation',
        key: 'designation',
        width: 140,
    },
    {
        title: 'Present Address',
        children: [
            {
                title: 'Line1',
                dataIndex: 'presentAddress_line1',
                key: 'presentAddress_line1',
                width: 270
            },
            {
                title: 'Line2',
                dataIndex: 'presentAddress_line2',
                key: 'presentAddress_line2',
                width: 270
            },
            {
                title: 'City',
                dataIndex: 'presentAddress_city',
                key: 'presentAddress_city',
                width: 140,
            },
            {
                title: 'State',
                dataIndex: 'presentAddress_state',
                key: 'presentAddress_state',
                width: 140,
            },
            {
                title: 'Zip Code',
                dataIndex: 'presentAddress_zipCode',
                key: 'presentAddress_zipCode',
                width: 140,
            },
        ],
    },
    {
        title: 'Permanent Address',
        children: [
            {
                title: 'Line1',
                dataIndex: 'permanentAddress_line1',
                key: 'permanentAddress_line1',
                width: 270
            },
            {
                title: 'Line2',
                dataIndex: 'permanentAddress_line2',
                key: 'permanentAddress_line2',
                width:270,

            },
            {
                title: 'City',
                dataIndex: 'permanentAddress_city',
                key: 'permanentAddress_city',
                width: 140,
            },
            {
                title: 'State',
                dataIndex: 'permanentAddress_state',
                key: 'permanentAddress_state',
                width: 140,
            },
            {
                title: 'Zip Code',
                dataIndex: 'permanentAddress_zipCode',
                key: 'permanentAddress_zipCode',
                width: 140,
            },
        ],
    },
    {
        title: 'Family Detail',
        children: [
            {
                title: 'Name',
                dataIndex: 'familyDetails_name',
                key: 'familyDetails_name',
                width: 100

            },
            {
                title: 'Gender',
                dataIndex: 'familyDetails_gender',
                key: 'familyDetails_gender',
                width: 100
            },
            {
                title: 'Relation Type',
                dataIndex: 'familyDetails_relationType',
                key: 'familyDetails_relationType',
                width: 140
            },
            {
                title: 'Mobile Number',
                dataIndex: 'familyDetails_mobileNumber',
                key: 'familyDetails_mobileNumber',
                width: 140
            },
        ],
    },
    {
        title: 'Experience',
        children: [
            {
                title: 'Employer Name',
                dataIndex: 'experiences_employerName',
                key: 'employerName',
                width: 140
            },
            {
                title: 'Designation',
                dataIndex: 'experiences_designation',
                key: 'experiences_designation',
                width: 140
            },
            {
                title: 'Total Exp',
                dataIndex: 'totalExperience',
                key: 'experiences_totalExperience',
                width: 140
            },
            {
                title: 'AnnualCTC',
                dataIndex: 'experiences_annualCTC',
                key: 'experiences_annualCTC',
                width: 140
            },
            {
                title: 'Skills',
                dataIndex: 'experiences_skills',
                key: 'experiences_skills',
                width: 140
            },
            {
                title: 'RFL',
                dataIndex: 'experiences_reasonForLeaving',
                key: 'experiences_reasonForLeaving',
                width: 140
            },
            {
                title: 'Duration',

                children: [
                    {
                        title: 'Start Date',
                        dataIndex: 'experiences_duration_startDate',
                        key: 'experiences_duration_startDate',
                        width: 140,
                    },
                    {
                        title: 'End Date',
                        dataIndex: 'experiences_duration_endDate',
                        key: 'experiences_duration_endDate',
                        width: 140,
                    },
                ],
            },
        ],
    },
    {
        title: 'Bank Detail',
        children: [
            {
                title: 'Account Holder Name',
                dataIndex: 'bankDetail_accountHolderName',
                key: 'bankDetail_accountHolderName',
                width: 140,
            },
            {
                title: 'Account Number',
                dataIndex: 'bankDetail_accountNumber',
                key: 'bankDetail_accountNumber',
                width: 140,
            },
            {
                title: 'IFSC Code',
                dataIndex: 'bankDetail_ifscCode',
                key: 'bankDetail_ifscCode',
                width: 140,
            },
            {
                title: 'Branch Name',
                dataIndex: 'bankDetail_branchName',
                key: 'bankDetail_branchName',
                width: 140,
            },
            {
                title: 'Branch Code',
                dataIndex: 'bankDetail_branchCode',
                key: 'bankDetail_branchCode',
                width: 140,
            },
        ],
    },
];

const PreviewEmployees = ({importedEmployeesRowData, errors}: any) => {
    return (
        <div>
            {importedEmployeesRowData?.length > 0 ?
                <Table
                    dataSource={importedEmployeesRowData}
                    // pagination={false}
                    pagination={{
                        hideOnSinglePage: true,
                        pageSize: 7,
                    }}
                    className={"employees-table"}
                    bordered={true}
                    columns={columns}
                    rootClassName={"preview-table"}
                    scroll={{x: 'max-content', y: 400}}
                    sticky
                    rowClassName={(_r, i) => {
                        const className = errors.find((item: any) => {
                            return item.line === i + 1 && item.errors.length > 0
                        }) ? 'show-error' : ''
                        return className;
                    }
                    } //todo add condition for color
                /> :
                <Empty
                    style={{
                        overflow: importedEmployeesRowData?.length ? "scroll" : "hidden",
                        maxHeight: 500,
                    }}
                    className={"no-data"}
                    description={"No data uploaded!"}/>}

        </div>)
}
export default PreviewEmployees;
